<template>
  <div>
    <QS-scroller-box>
      <QS-h3-title title="采购批量退车" has-bottom-line />
      <QS-h4-title title="采购订单信息" />
      <el-form class="baseInfo">
        <QSColumnBox
          :source="baseInfo"
          :list="baseInfoList"
          :separator="columnSeparator"
          label-width="120"
        >
          <el-form-item
            label="合同附件:"
            prop="contractAttachment"
            class="enclosure alone"
            label-width="120px"
          >
            <div v-if="this.baseInfo.contractAttachment.length > 0">
              <div
                v-for="(item, index) in this.baseInfo.contractAttachment"
                :key="'baseInfo' + index"
                class="uptext"
              >
                <p v-down="{ url: item.url, name: item.name }" class="blue">
                  <i class="el-icon-document blue"></i>
                  {{ item.name }}
                </p>
              </div>
            </div>
            <div v-else>--</div>
          </el-form-item>
        </QSColumnBox>
      </el-form>
      <QS-h4-title title="退车车辆信息" />
      <exitCarInfo
        ref="exitCarInfoRef"
        :orderId="orderId"
        @tableLoading="
          v => {
            this.submitLoading = v
          }
        "
      />
      <template slot="bottomAction">
        <el-button @click="pageGoBack">取消</el-button>
        <el-button
          v-show="!approvalStateStatus"
          :loading="submitLoading"
          type="primary"
          @click="submit"
          v-submitDingTalkShow="25"
          >确定</el-button
        >
        <el-button
          v-show="approvalStateStatus"
          type="primary"
          @click="handleShowApprovalTask"
          >查看审批动态</el-button
        >
      </template>
    </QS-scroller-box>
    <ApprovalTaskDetail
      :approvalTaskDetailDialogVisible.sync="approvalTaskDetailDialogVisible"
      :bizId="orderId"
      bizType="25"
    />
  </div>
</template>
<script>
import selectOption from '@/store/dict/selectOptionDict'
// eslint-disable-next-line import/no-cycle
import { getPurchaseDetail, confirmSettlement } from '@/api/domain/purchase.js'
import exitCarInfo from '../../components/exitCarInfo.vue'
import moment from 'moment'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import ApprovalTaskDetail from '@/components/ApprovalTaskDetail/index.vue'

export default {
  components: { exitCarInfo, ApprovalTaskDetail },
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      approvalState: '', // 当前审批状态 10 带审批 （前端展示审批动态） 20 已经撤回 30 已驳回 40 已通过
      approvalTaskDetailDialogVisible: false,
      submitLoading: false,
      baseInfo: {
        contractAttachment: '',
      },
      // routerFrom: '', // 从哪里跳到这个页面的
      baseInfoList: [
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'type',
          name: '订单类型',
        },
        {
          key: 'purchaseMode',
          name: '采购方式',
        },
        {
          key: 'state',
          name: '订单状态',
        },
        {
          key: 'providerName',
          name: '车源方',
        },
        {
          key: 'providerId',
          name: '车源方ID',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'contractStartDate',
          name: '合同开始日期',
        },
        {
          key: 'contractEndDate',
          name: '合同结束日期',
        },
        {
          key: 'contractNo',
          name: '业务合同编号',
        },
      ],
    }
  },
  created() {
    this.getDetails()
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.setItem('batchExitCarlistRouterFrom', from.name)
    next()
  },
  computed: {
    orderId() {
      return this.$route.query.id
    },
    approvalStateStatus() {
      return Number(this.approvalState) === 10
    },
  },
  methods: {
    // 点击查看 审批流进程 处理新增 钉钉审批流 财务场景
    async handleShowApprovalTask() {
      this.approvalTaskDetailDialogVisible = true
    },
    // 提交批量退车
    submit() {
      const { list } = this.$refs.exitCarInfoRef.formTable
      const returnCarInfo = []
      // 获取退车参数列表
      list.forEach((item) => {
        returnCarInfo.push({
          orderId: item.id,
          takeOverTime: `${moment(item.returnCarDate).format(
            'YYYY-MM-DD',
          )} 00:00:00`,
        })
      })
      // console.log(returnCarInfo)
      // return
      if (list.length === 0) {
        this.$message.warning('请选择需要退车的车辆')
        return
      }
      // 校验退车时间是否已填写
      this.$refs.exitCarInfoRef.$refs.formTableRef.validate((valid) => {
        if (valid) {
          confirmSettlement({
            returnCarInfo,
            orderId: this.$route.query.id, // 采购订单ID
          }).then((res) => {
            if (res.code === 1) {
              const msg = this.DingTalkShow25 ? '提交审批成功' : '操作成功'
              this.$message.success(msg)
              this.getDetails()
              this.pageGoBack(true)
            }
          })
        } else {
          this.$message.warning('请填写必填项')
        }
      })
    },
    pageGoBack(status = false) {
      this.$refreshBack(status)
    },
    // 详情页请求数据
    async getDetails() {
      const { code, data } = await getPurchaseDetail({
        id: this.orderId, // 采购订单ID
      })
      if (code === 1) {
        // 新增字段 判断当前流程是否在审批中 20231024 钉钉审批流 财务场景
        this.approvalState = data.approvalState
        data.orderInfo.purchaseMode =
          Number(data.orderInfo.purchaseMode) === 1 ? '购买' : '租赁'
        this.baseInfo = data.orderInfo // 采购订单基本信息
        this.parseInfo()
      }
    },
    // 获取采购订单信息内容
    parseInfo() {
      const type = selectOption.typeofcontractDict[2]
      const purchaseType =
        selectOption.purchaseTypeDict[this.baseInfo.purchaseType]
      const state = selectOption.purchaseStateDict[this.baseInfo.state]
      const contractAttachment = this.getEchoUploadFileData(this.baseInfo.contractAttachment, true)
      this.baseInfo = {
        ...this.baseInfo,
        type,
        purchaseType,
        state,
        contractAttachment,
      }
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .column-title {
  text-align: right;
  padding-right: 10px;
  color: #333333;
  min-width: 115px !important;
}
.baseInfo ::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.uptext {
  .blue {
    color: #2e7eff;
    display: inline-block;
    margin: 0;
  }
}
</style>
